import createVueApp from '@phoenix/createVueApp';
import { PhxTimeline } from '@phx-styleguides/iwc';

document.querySelectorAll('.phoenix-timeline').forEach((el) => {
  const app = createVueApp({});
  app.component('PhxTimeline', PhxTimeline);
  app.mount(el);
});
